import { render } from "./Coordinates.vue?vue&type=template&id=63ebfd55"
import script from "./Coordinates.vue?vue&type=script&lang=js"
export * from "./Coordinates.vue?vue&type=script&lang=js"

import "./Coordinates.vue?vue&type=style&index=0&id=63ebfd55&lang=scss"

import exportComponent from "/Users/william/Documents/beadographer3/bead3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__